import {ActionMenuSection} from '#/components/actionmenu/types';
import {Layout} from '#/components/layout/layout';
import Map from '#/components/map/component';
import {SLQueryParamConfig} from '#/contexts/query-params-provider';
import {useQueryNavigationActions} from '#/hooks/use-query-navigation-actions';
import {Page} from '#/pages/page';
import {Land, UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import {useQueryParams} from 'use-query-params';

const MapPage: FunctionComponent = () => {
  const {t} = useTranslation('translation');

  const [{action}] = useQueryParams<SLQueryParamConfig>();
  const {openLandOnMap} = useQueryNavigationActions();

  const onSearch = (land: Land | UnlistedLand) => {
    openLandOnMap(land, ActionMenuSection.INFORMATION);
  };

  return (
    <Page title={t('pages.map.htmlTitle')}>
      <Layout variant='sticky' onSearch={onSearch}>
        <Map mapCenterOffsetX={!!action ? 500 : undefined} />
      </Layout>
    </Page>
  );
};

export default MapPage;
